/**
 * A task is "framework-migrated" if its template has at least one location.
 * Tasks without a location (legacy launchpad, tax tracker, etc.) have their
 * own dedicated flows and shouldn't render on the new Tasks surfaces.
 *
 * Structural typing — accepts both `Task` and `OperatorTask` since both share
 * the `task_template.location: string[]` shape.
 */
export default function isFrameworkTask(task: { task_template: { location?: string[] } }): boolean {
    return (task.task_template.location?.length ?? 0) > 0;
}
